import { render, staticRenderFns } from "./document-list.vue?vue&type=template&id=36434a51&scoped=true&"
import script from "./document-list.vue?vue&type=script&lang=js&"
export * from "./document-list.vue?vue&type=script&lang=js&"
import style0 from "./document-list.vue?vue&type=style&index=0&id=36434a51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36434a51",
  null
  
)

/* custom blocks */
import block0 from "./document-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./document-list.vue?vue&type=custom&index=1&blockType=graphql"
if (typeof block1 === 'function') block1(component)
import block2 from "./document-list.vue?vue&type=custom&index=2&blockType=fragments"
if (typeof block2 === 'function') block2(component)

export default component.exports